import React, { useState } from "react";
import "./filters.scss";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../../components/Button";
import { BooleanFilters } from "./BooleanFilters";
import { DateRangeFilters } from "./DateRangeFilters";
import { PropertyFilters } from "./PropertyFilters";
import { IssueTypeFilter } from "./IssueTypeFilter";
import { AssetTypeFilter } from "./AssetTypeFilter";
import { TagFilter } from "./TagFilter";
import { isRole } from "../../../../../helpers/permissions";
import { ServiceProviderFilter } from "./ServiceProviderFilter";
import { selectFilters } from "../../../../../store/selectors/serviceRequestDashboard/filters";
import { applyFilters } from "../../../../../store/actions/serviceRequestDashboard/filters";

export const FilterModal = ({
  onClose
}) => {
  const auth = useSelector((state) => state.auth);

  const filters = useSelector(selectFilters);
  const dispatch = useDispatch();

  const roleCondition = isRole(
    [
      "Admin",
      "Super Admin",
      "Property Developer",
      "Service Manager",
      "Strata Manager",
    ],
    auth.user
  );

  const [dates, setDates] = useState({
    startDate: filters?.SubmittedFrom
      ? moment(filters?.SubmittedFrom).toDate()
      : null,
    endDate: filters?.SubmittedTo
      ? moment(filters?.SubmittedTo).toDate()
      : null,
  });

  const [propertyFilters, setPropertyFilters] = useState({
    suite: filters.UnitId ?? [],
    project: filters?.PropertyId ?? "",
    building: filters?.BuildingId ?? "",
    level: filters?.LevelId ?? "",
  });
  const { suite, project, building, level } = propertyFilters;

  const [booleanFilters, setBooleanFilters] = useState(
    filters?.booleanFilters ?? []
  );

  const [issueType, setIssueType] = useState(filters?.ServiceType);
  const [assetType, setAssetType] = useState(filters?.ItemTypeId);
  const [tags, setTags] = useState(filters?.TagIds ?? []);
  const [assignTo, setAssignTo] = useState(filters?.AssignedToServiceProviderId);

  function handleSubmit() {
    dispatch(applyFilters(
      {
        booleanFilters,
        AssignedToServiceProviderId: assignTo,
        SubmittedFrom: dates.startDate
          ? moment(dates.startDate).format("YYYY-MM-DD")
          : null,
        SubmittedTo: dates.endDate
          ? moment(dates.endDate).format("YYYY-MM-DD")
          : null,
        PropertyId: project,
        UnitId: suite,
        BuildingId: building,
        LevelId: level,
        TagIds: tags,
        ServiceType: issueType,
        ItemTypeId: assetType,
      }
    ));
    onClose();
  }
  return (
    <>
      <div className="filters-modal__heading">Filter By</div>
      <div className="filters_modal_top_coner_box">
        <div className="filters_modal_close_icon" onClick={onClose}>
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.96 12.75L19.5 18.29V19.75H18.04L12.5 14.21L6.96 19.75H5.5V18.29L11.04 12.75L5.5 7.21V5.75H6.96L12.5 11.29L18.04 5.75H19.5V7.21L13.96 12.75Z"
              fill="black"
            />
          </svg>
        </div>
      </div>

      <BooleanFilters
        booleanFilters={booleanFilters}
        setBooleanFilters={setBooleanFilters}
      />
      <DateRangeFilters dates={dates} setDates={setDates} />
      <PropertyFilters
        propertyFilters={propertyFilters}
        setPropertyFilters={setPropertyFilters}
      />
      <IssueTypeFilter
        setSelectedIssueType={setIssueType}
        issueType={issueType}
      />
      <AssetTypeFilter
        assetType={assetType}
        setSelectedAssetType={setAssetType}
      />

      {roleCondition && (
        <ServiceProviderFilter
          assignedTo={assignTo}
          setAssignedTo={setAssignTo}
        />
      )}

      <TagFilter tags={tags} setTags={setTags} />

      <div style={{ textAlign: "center" }}>
        <Button
          color="teal"
          label="Submit"
          size="small"
          onClick={handleSubmit}
        />
      </div>
    </>
  );
};
